export default __webpack_public_path__ + "static/media/dialog_question.e55160fe.svg";